import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M18.2058 16.2058C17.2182 17.1934 15.1382 19.2733 13.735 20.6765C12.954 21.4576 11.6885 21.4569 10.9074 20.6759C9.52858 19.297 7.49008 17.2585 6.43733 16.2058C3.18756 12.956 3.18756 7.68709 6.43733 4.43733C9.68709 1.18756 14.956 1.18756 18.2058 4.43733C21.4555 7.68709 21.4555 12.956 18.2058 16.2058Z",
        fill: "none",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      _createElementVNode("path", {
        d: "M15.4421 10.3216C15.4421 12.045 14.045 13.4421 12.3216 13.4421C10.5981 13.4421 9.20097 12.045 9.20097 10.3216C9.20097 8.5981 10.5981 7.20097 12.3216 7.20097C14.045 7.20097 15.4421 8.5981 15.4421 10.3216Z",
        fill: "none",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }